import { callApi } from "modules/core/api/services";
import { ApiResponse } from "modules/core/api/types";
import { Team } from "types/interfaces/Team";

export const getPlayers = () =>
  callApi<ApiResponse<Team[]>>(`/v2/players?page=1&per_page=50`);
